exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.select-a-game__resolution-switch .switchery small {\n\tbox-shadow: none;\n}\n", ""]);

// exports
